module.exports = __webpack_public_path__ + "static/media/ET.b66cf097.png";